import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m20.848 20.1405-6.8795-6.6465c1.0154-1.1482 1.548-2.6444 1.4863-4.17603-.0616-1.5316-.7127-2.98015-1.8171-4.04306-1.1045-1.06291-2.5769-1.65798-4.10977-1.6609-1.53284-.00292-3.00752.58653-4.11601 1.64523-1.1085 1.0587-1.76506 2.50476-1.83254 4.03611-.06749 1.53135.45932 3.02955 1.47039 4.18165 1.01106 1.1521 2.42818 1.869 3.95533 2.0009 1.5272.132 3.0462-.3313 4.2399-1.2929l6.9085 6.6745zm-16.348-10.641c0-.9889.29324-1.9556.84265-2.77785.5494-.82224 1.3303-1.46311 2.24393-1.84155.91363-.37843 1.91896-.47745 2.88882-.28452.97.19292 1.8609.66913 2.5601 1.36839.6993.69926 1.1755 1.59018 1.3684 2.56008.1929.96991.0939 1.97525-.2845 2.88885-.3784.9137-1.0193 1.6945-1.8416 2.244-.8222.5494-1.7889.8426-2.7778.8426-1.3256-.0016-2.59645-.5289-3.53379-1.4662-.93733-.9374-1.46463-2.2082-1.46621-3.5338z",
		fill: "#000"
	})
});
export default SvgMagnifyingGlass;
